(function(){
  'use strict';

  const selectors = {
    section: '[data-section-type]',
    productImages: 'product-images',
    productMedia: '[data-image-id]',
    mediaIdAttr: 'data-media-id',
    activeMediaAttr: 'data-active-media',
    dots: '[data-product-dots]'
  };

  function closestSection(el){
    return el.closest(selectors.section);
  }

  function setActiveDot(dotsEl, id){
    if (!dotsEl) return;
    dotsEl.querySelectorAll('.flickity-page-dot').forEach((dot)=>{
      if (dot.getAttribute(selectors.mediaIdAttr) === id){
        dot.classList.add('is-selected');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('is-selected');
        dot.removeAttribute('aria-current');
      }
    });
  }

  function initDots(container){
    if (!container) return;

    const dotsEl = container.querySelector(selectors.dots);
    if (!dotsEl) return;

    const imagesComponent = container.querySelector(selectors.productImages);
    if (!imagesComponent) return;

    // Sync initial state
    const currentId = imagesComponent.getAttribute(selectors.activeMediaAttr);
    if (currentId) setActiveDot(dotsEl, currentId);

    // Handle arrow/swipe changes coming from product-images component
    imagesComponent.addEventListener('theme:media:select', (e) => {
      const id = e.detail && e.detail.id;
      if (id) setActiveDot(dotsEl, id);
    });

    // Clicking on dots selects media
    dotsEl.querySelectorAll('.flickity-page-dot').forEach((dot) => {
      dot.addEventListener('click', () => {
        const id = dot.getAttribute(selectors.mediaIdAttr);
        if (!id) return;
        imagesComponent.dispatchEvent(new CustomEvent('theme:media:select', { detail: { id } }));
      });

      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dot.click();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Initialize on product sections
    document.querySelectorAll('product-component').forEach((section) => initDots(section));
    console.log("product-dots.js loaded")
  });
})();
